<template>
  <default-layout>
    <div>
      <h3 class="title is-3">Applications</h3>
    </div>
    <b-tabs v-model="activeTab">
      <b-tab-item label="Pending">
        <applications-list stage="pending" v-if="activeTab === 0"></applications-list>
      </b-tab-item>
      <b-tab-item label="Approved">
        <applications-list stage="approved" v-if="activeTab === 1"></applications-list>
      </b-tab-item>
      <b-tab-item label="Rejected">
        <applications-list stage="rejected" v-if="activeTab === 2"></applications-list>
      </b-tab-item>
    </b-tabs>
  </default-layout>
</template>

<script>
import ApplicationsList from '../components/applications/ApplicationsList.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'

export default {
  components: {
    DefaultLayout,
    ApplicationsList
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>
